"use client";

import React from "react";
import { Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
const teamMembers = [{
  name: "Alex 'Volt' Rivers",
  position: "Lead Mixing Engineer",
  bio: "With a decade in the underground electronic scene, Alex specializes in 'High-Voltage Clarity'. His sonic signature is defined by aggressive transients and a surgical approach to low-end management. He has shaped the sound of chart-topping synth-pop and industrial techno projects, ensuring every beat hits with maximum impact.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/engineer_alex_rivers.png",
  email: "volt@pulsewave.studio",
  phone: "+1 555 982 4000"
}, {
  name: "Sarah 'Silk' Chen",
  position: "Mastering Specialist",
  bio: "Sarah is the architect of 'Velvet Resonance'. Her mastering philosophy focuses on harmonic warmth and spatial depth, utilizing a rare collection of vintage tube gear. She brings a refined, analog soul to digital productions, making her the go-to engineer for indie-folk and cinematic soul artists seeking that elusive 'expensive' sound.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/engineer_sarah_chen.png",
  email: "silk@pulsewave.studio",
  phone: "+1 555 982 4001"
}, {
  name: "Marcus 'Deep' Thorne",
  position: "Recording Engineer",
  bio: "Marcus is a master of 'Atmospheric Immersion'. Known for his unconventional mic placements and obsession with room acoustics, he captures the raw energy of live sessions. His signature sound is wide, organic, and deeply emotive, bridging the gap between technical perfection and artistic vulnerability.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655264/img/engineer_marcus_thorne.png",
  email: "deep@pulsewave.studio",
  phone: "+1 555 982 4002"
}];
export default function NuestroEquipo() {
  return <section data-section-id="222127" id="the-engineers" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 max-w-3xl">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-6 tracking-tighter">
            The Engineers
          </h2>
          <p className="text-lg text-muted-foreground font-default leading-relaxed">
            The sonic architects behind PulseWave. A collective of specialists dedicated to the art of high-fidelity sound, blending technical precision with raw creative intuition.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {teamMembers.map((member, i) => <div key={i} data-index={i}>
              <Dialog>
                <DialogTrigger asChild>
                  <button className="group w-full text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-3xl cursor-pointer">
                    <div className="overflow-hidden rounded-3xl mb-6 bg-card aspect-[3/4] shadow-lg transition-all duration-500 group-hover:shadow-primary/20 group-hover:shadow-2xl border border-border/50">
                      <img src={member.image} alt={`Portrait of ${member.name}`} className="w-full h-full object-cover grayscale brightness-75 transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:brightness-100 group-hover:scale-105" />
                    </div>
                    <div className="space-y-1.5">
                      <h3 className="font-default text-2xl font-bold text-foreground transition-colors group-hover:text-primary">
                        {member.name}
                      </h3>
                      <p className="font-mono text-primary uppercase tracking-widest text-xs font-bold">
                        {member.position}
                      </p>
                    </div>
                  </button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-[800px] p-0 overflow-hidden border-border bg-card/95 backdrop-blur-xl rounded-3xl shadow-4xl">
                  <div className="grid grid-cols-1 md:grid-cols-5 h-full">
                    <div className="hidden md:block md:col-span-2 bg-muted h-full relative">
                      <img src={member.image} alt={`Photography of ${member.name}`} className="absolute inset-0 w-full h-full object-cover" />
                    </div>
                    <div className="p-8 md:p-12 flex flex-col justify-center md:col-span-3">
                      <DialogHeader className="mb-8 text-left space-y-2">
                        <DialogTitle className="font-default text-3xl md:text-4xl font-bold text-foreground">
                          {member.name}
                        </DialogTitle>
                        <DialogDescription className="font-mono text-primary uppercase tracking-widest text-xs font-bold">
                          {member.position}
                        </DialogDescription>
                      </DialogHeader>
                      <div className="space-y-8">
                        <p className="font-default text-muted-foreground leading-relaxed text-sm md:text-base">
                          {member.bio}
                        </p>
                        <div className="pt-8 border-t border-border space-y-5">
                          <Link to={`mailto:${member.email}`} className="flex items-center gap-4 text-sm font-default text-foreground hover:text-primary transition-colors group w-fit">
                            <div className="p-2.5 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors">
                              <Mail className="size-4 text-primary" />
                            </div>
                            <span className="tracking-wide">{member.email}</span>
                          </Link>
                          <Link to={`tel:${member.phone.replace(/\s/g, "")}`} className="flex items-center gap-4 text-sm font-default text-foreground hover:text-primary transition-colors group w-fit">
                            <div className="p-2.5 rounded-full bg-primary/10 group-hover:bg-primary/20 transition-colors">
                              <Phone className="size-4 text-primary" />
                            </div>
                            <span className="tracking-wide">{member.phone}</span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
      </div>
    </section>;
}